function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "financialTitle"
}, "financial");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M45.373 27.746c7.521 3.51 10.83 15.57 11.615 24.595.09 1.2-.32 2.385-1.132 3.269-.811.884-1.95 1.387-3.145 1.39h-25.4c-1.199.003-2.344-.498-3.16-1.382-.816-.885-1.229-2.072-1.139-3.277.795-9.025 4.051-21.095 11.615-24.595h10.746zm-5.05 7.115c-1.53 0-2.752.454-3.662 1.36-.854.851-1.308 2.002-1.36 3.453l-.006.295.076 1.996h-1.676v3h1.774l.033.735c0 .394-.046.785-.137 1.171-.09.387-.223.716-.397.987-.15.233-.333.388-.552.465l-.112.031h-.109v2.978h11.178v-4.427h-2.808l-.098 1.45h-4.473c.45-.417.793-.872 1.028-1.367.203-.423.318-.857.347-1.3l.007-.222-.022-.502h3.298v-3h-3.439l-.109-1.995c0-.677.104-1.2.31-1.567.207-.368.506-.552.898-.552.385 0 .704.143.958.43.226.254.351.639.376 1.155l.005.2h3.744l.022-.068c.036-1.42-.396-2.559-1.295-3.418-.9-.858-2.166-1.288-3.799-1.288zM48.207 17l-3.188 8.358H34.394L31.207 17h17z",
  transform: "translate(-216 -753) translate(216 753)"
}))));

var SvgPrimaryButtonUiFinancialIcon = function SvgPrimaryButtonUiFinancialIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    "aria-labelledby": "financialTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "financialTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiFinancialIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-financial-icon.a90a81cb.svg";
export { ForwardRef as ReactComponent };